import { render } from "./dialog-car-info.vue?vue&type=template&id=1a1437e4&scoped=true"
import script from "./dialog-car-info.vue?vue&type=script&lang=js"
export * from "./dialog-car-info.vue?vue&type=script&lang=js"

import "./dialog-car-info.vue?vue&type=style&index=0&id=1a1437e4&lang=scss&scoped=true"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1437e4"]])

export default __exports__